import { AXIS_HEIGHT } from '../constants.js';

export const getSparklineHeight = (
  containerHeight: number,
  showTicks: boolean,
) => {
  const height = showTicks ? containerHeight - AXIS_HEIGHT : containerHeight;

  return Math.max(0, height);
};
